import React, { FC } from 'react'
import RadioButton from '../../Atoms/RadioButton/RadioButton'
import { RadioGroupProps } from './types'
import Fieldset from '../../Layout/Fieldset/Fieldset'
import { LabelWrapper, RadioGroupWrapper } from './RadioGroup.styles'
import Flex from '../../Layout/Flex/Flex'
import Label from '../../Atoms/Label/Label'

const RadioGroup: FC<RadioGroupProps> = props => {
  const { dataList, disabled } = props
  if (dataList?.length === 0) return null

  return (
    <RadioGroupWrapper gridArea={props?.gridArea} minHeight={props.minHeight} margin={props.margin} flexProperties={props.flexProperties} responsive={props.responsive}>
      <Fieldset>
        {props.label && <LabelWrapper marginBottom={props.marginBottom}>
          <Label
            label={props.label}
            name={props.name}
            required={props.required}
            tooltipLabel={props.tooltipLabel}
            bold={props.labelBold}
            removeEllipsis={props.removeLabelEllipsis}
            flexWrapperMinHeight={props.flexWrapperMinHeight}
          />
        </LabelWrapper>}
        <Flex {...props.flex} alignItems='flex-start'>
          {dataList?.map(data => {
            const newData = data
            if (typeof newData.value === 'boolean') {
              data.value = `${data.value}`
            }
            return (
              <RadioButton
                key={data.id}
                name={props.name}
                removeMargins={props.removeButtonMargins}
                defaultChecked={props.value === newData.value}
                onChange={props.onChange}
                disabled={disabled}
                {...newData}
              />
            )
          })}
        </Flex>
      </Fieldset>
    </RadioGroupWrapper>
  )
}

RadioGroup.defaultProps = {
  label: '',
  value: '',
  required: false,
  flex: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    alignContent: 'center',
  },
  dataList: [],
}

export default RadioGroup
